module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "member-packet"
  }, [_c('div', {
    staticClass: "banner_wrapper"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("会员功能")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("会员红包")])], 1), _vm._v(" "), _c('div', {
    staticClass: "banner-btn",
    on: {
      "click": _vm.creatPackage
    }
  }, [_c('i', {
    staticClass: "icon-create"
  }), _vm._v(" "), _c('span', {
    staticClass: "banner-btn__desc"
  }, [_vm._v("新建红包")])])], 1), _vm._v(" "), _c('div', {
    class: _vm.origin == 'yirui' ? '.yirui-panel' : 'panel'
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('div', {
    staticClass: "panel-select-group"
  }, [_c('div', {
    staticClass: "btn-select"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.role.single),
      expression: "!role.single"
    }],
    staticClass: "panel-select__wrapper"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v("店铺名称")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "全部",
      "size": "small"
    },
    on: {
      "change": _vm.nameChange
    },
    model: {
      value: (_vm.nameValue),
      callback: function($$v) {
        _vm.nameValue = $$v
      },
      expression: "nameValue"
    }
  }, _vm._l((_vm.shopData.list), function(shop) {
    return _c('el-option', {
      key: shop.uid,
      attrs: {
        "label": shop.shop_name,
        "value": shop.uid
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-select__wrapper"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v("红包类型")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "全部",
      "size": "small"
    },
    on: {
      "change": _vm.packetChange
    },
    model: {
      value: (_vm.packetValue),
      callback: function($$v) {
        _vm.packetValue = $$v
      },
      expression: "packetValue"
    }
  }, _vm._l((_vm.packetList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('div', {
    staticClass: "panel-header-btn"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'packetbill'
      }
    }
  }, [_vm._v("红包账单")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.redpacketData.list,
      "row-class-name": "el-table__row_fix",
      "id": "memberredpacket"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "创建时间",
      "min-width": "145"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "title",
      "label": "活动名称",
      "min-width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type_str",
      "label": "红包类型",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "活动状态",
      "prop": "status_str"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "活动时间",
      "min-width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_c('span', {
          staticClass: "scope_cotent_title"
        }, [_vm._v("开始时间")]), _vm._v(_vm._s(_vm._f("removeHMS")(scope.row.start_time)))]), _vm._v(" "), _c('p', [_c('span', {
          staticClass: "scope_cotent_title"
        }, [_vm._v("结束时间")]), _vm._v(_vm._s(_vm._f("removeHMS")(scope.row.expire_time)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "giveout_num",
      "label": "领取数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "150",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticClass: "el-button__fix",
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.showDetail(scope)
            }
          }
        }, [_vm._v("查看详情")]), _vm._v(" "), _c('el-dropdown', {
          attrs: {
            "hide-on-click": true
          },
          on: {
            "command": function($event) {
              _vm.cancelAct(scope)
            }
          }
        }, [_c('span', {
          staticClass: "el-dropdown-link el-dropdown-link__fix"
        }, [_vm._v("\n                更多"), _c('i', {
          staticClass: "el-icon-caret-bottom el-icon--right"
        })]), _vm._v(" "), _c('el-dropdown-menu', {
          staticClass: "el-dropdown-menu__fix",
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [_c('el-dropdown-item', {
          staticClass: "el-dropdown-item__fix",
          attrs: {
            "disabled": scope.row.status === 3
          }
        }, [_vm._v("终止活动")])], 1)], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), (_vm.redpacketData.total >= 10) ? _c('div', {
    staticClass: "pagination_wrapper"
  }, [_c('el-pagination', {
    ref: "page",
    attrs: {
      "layout": "total, sizes, prev, pager, next, jumper",
      "page-size": _vm.pageSize,
      "total": _vm.redpacketData.total,
      "current-page": _vm.currentpage
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.currentChange
    }
  }, [_vm._v(">\n      ")])], 1) : _c('div', {
    staticClass: "table_placeholder"
  })]), _vm._v(" "), _c('el-dialog', {
    staticClass: "detail_dialog",
    attrs: {
      "title": "红包详情"
    },
    model: {
      value: (_vm.isShowDetail),
      callback: function($$v) {
        _vm.isShowDetail = $$v
      },
      expression: "isShowDetail"
    }
  }, [(_vm.detailData.type === 'type_common') ? [_c('el-row', [_c('el-col', {
    staticClass: "title",
    attrs: {
      "span": 5
    }
  }, [_vm._v("红包类型")]), _vm._v(" "), _c('el-col', {
    staticClass: "desc",
    attrs: {
      "span": 19
    }
  }, [_vm._v(_vm._s(_vm.detailData.type_str))])], 1), _vm._v(" "), (!_vm.role.single) ? _c('el-row', [_c('el-col', {
    staticClass: "title",
    attrs: {
      "span": 5
    }
  }, [_vm._v("适用门店")]), _vm._v(" "), _c('el-col', {
    staticClass: "desc",
    attrs: {
      "span": 19
    }
  }, _vm._l((_vm.detailData.effect_sub_merchant), function(shop, index) {
    return _c('span', [_vm._v(_vm._s(shop.shopname) + _vm._s(index < _vm.detailData.effect_sub_merchant.length - 1 ? "、" : ""))])
  }))], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "title",
    attrs: {
      "span": 5
    }
  }, [_vm._v("通知会员数")]), _vm._v(" "), _c('el-col', {
    staticClass: "desc",
    attrs: {
      "span": 19
    }
  }, [_vm._v(_vm._s(_vm.member_total) + "人")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "title",
    attrs: {
      "span": 5
    }
  }, [_vm._v("单个红包金额")]), _vm._v(" "), _c('el-col', {
    staticClass: "desc",
    attrs: {
      "span": 19
    }
  }, [_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.detailData.share_info.amt_max)))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "title",
    attrs: {
      "span": 5
    }
  }, [_vm._v("红包有效期")]), _vm._v(" "), _c('el-col', {
    staticClass: "desc",
    attrs: {
      "span": 19
    }
  }, [_vm._v(_vm._s(_vm.detailData.share_info.coupon_rule.effect_len) + "天")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "title",
    attrs: {
      "span": 5
    }
  }, [_vm._v("通知时间")]), _vm._v(" "), _c('el-col', {
    staticClass: "desc",
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "desc-item"
  }, [_vm._v(_vm._s(_vm.detailData.notify_time))]), _vm._v(" "), _c('div', {
    staticClass: "remark"
  }, [_vm._v("备注：红包费用由商户承担")])])], 1)] : _vm._e(), _vm._v(" "), (_vm.detailData.type === 'type_sharing') ? [_c('el-row', [_c('el-col', {
    staticClass: "title",
    attrs: {
      "span": 5
    }
  }, [_vm._v("活动名称")]), _vm._v(" "), _c('el-col', {
    staticClass: "desc",
    attrs: {
      "span": 19
    }
  }, [_vm._v(_vm._s(_vm.detailData.act_name))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "title",
    attrs: {
      "span": 5
    }
  }, [_vm._v("红包类型")]), _vm._v(" "), _c('el-col', {
    staticClass: "desc",
    attrs: {
      "span": 19
    }
  }, [_vm._v(_vm._s(_vm.detailData.type_str))])], 1), _vm._v(" "), (!_vm.role.single) ? _c('el-row', [_c('el-col', {
    staticClass: "title",
    attrs: {
      "span": 5
    }
  }, [_vm._v("适用门店")]), _vm._v(" "), _c('el-col', {
    staticClass: "desc",
    attrs: {
      "span": 19
    }
  }, _vm._l((_vm.detailData.effect_sub_merchant), function(shop, index) {
    return _c('span', [_vm._v(_vm._s(shop.shopname) + _vm._s(index < _vm.detailData.effect_sub_merchant.length - 1 ? "、" : ""))])
  }))], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "title",
    attrs: {
      "span": 5
    }
  }, [_vm._v("活动开始时间")]), _vm._v(" "), _c('el-col', {
    staticClass: "desc",
    attrs: {
      "span": 19
    }
  }, [_vm._v(_vm._s(_vm.detailData.start_time))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "title",
    attrs: {
      "span": 5
    }
  }, [_vm._v("活动结束时间")]), _vm._v(" "), _c('el-col', {
    staticClass: "desc",
    attrs: {
      "span": 19
    }
  }, [_vm._v(_vm._s(_vm.detailData.expire_time))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "title",
    attrs: {
      "span": 5
    }
  }, [_vm._v("总预算")]), _vm._v(" "), _c('el-col', {
    staticClass: "desc",
    attrs: {
      "span": 19
    }
  }, [_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.detailData.total_amt)) + "元")])], 1), _vm._v(" "), _c('el-row', [(_vm.packetType === 0) ? [_c('el-col', {
    staticClass: "title",
    attrs: {
      "span": 5
    }
  }, [_vm._v("单个红包金额")]), _vm._v(" "), _c('el-col', {
    staticClass: "desc",
    attrs: {
      "span": 19
    }
  }, [_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.detailData.share_info.amt_max)) + "元")])] : _vm._e(), _vm._v(" "), (_vm.packetType === 1) ? [_c('el-col', {
    staticClass: "title",
    attrs: {
      "span": 5
    }
  }, [_vm._v("单个红包金额")]), _vm._v(" "), _c('el-col', {
    staticClass: "desc",
    attrs: {
      "span": 19
    }
  }, [_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.detailData.share_info.amt_min)) + " - " + _vm._s(_vm._f("formatCurrency")(_vm.detailData.share_info.amt_max)) + "元")])] : _vm._e()], 2), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "title",
    attrs: {
      "span": 5
    }
  }, [_vm._v("红包规则")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "desc"
  }, [_c('div', {
    staticClass: "desc-item"
  }, [_vm._v("会员微信扫描收款二维码"), _c('span', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.detailData.share_info.rule.amt)))]), _vm._v("元可分享红包；")]), _vm._v(" "), _c('div', {
    staticClass: "desc-item"
  }, [_vm._v("每个分享链接可以有10人领取红包，每人只能领取一个；")]), _vm._v(" "), _c('div', {
    staticClass: "desc-item"
  }, [_vm._v("红包领取后"), _c('span', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm.effectList[_vm.detailData.share_info.coupon_rule.effect_offset]) + ",")]), _c('span', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm.detailData.share_info.coupon_rule.effect_len))]), _vm._v("日内有效；")]), _vm._v(" "), _c('div', {
    staticClass: "desc-item"
  }, [_vm._v("会员有效期内微信扫描收款码"), _c('span', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.detailData.share_info.coupon_rule.use_rule.amt)))]), _vm._v("元以上可用；")])]), _vm._v(" "), _c('div', {
    staticClass: "remark"
  }, [_vm._v("备注：会员红包费用由商户承担")])])], 1)] : _vm._e(), _vm._v(" "), (_vm.detailData.type === 'type_payment') ? [_c('el-row', [_c('el-col', {
    staticClass: "title",
    attrs: {
      "span": 5
    }
  }, [_vm._v("活动名称")]), _vm._v(" "), _c('el-col', {
    staticClass: "desc",
    attrs: {
      "span": 19
    }
  }, [_vm._v(_vm._s(_vm.detailData.act_name))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "title",
    attrs: {
      "span": 5
    }
  }, [_vm._v("红包类型")]), _vm._v(" "), _c('el-col', {
    staticClass: "desc",
    attrs: {
      "span": 19
    }
  }, [_vm._v(_vm._s(_vm.detailData.type_str))])], 1), _vm._v(" "), (!_vm.role.single) ? _c('el-row', [_c('el-col', {
    staticClass: "title",
    attrs: {
      "span": 5
    }
  }, [_vm._v("适用门店")]), _vm._v(" "), _c('el-col', {
    staticClass: "desc",
    attrs: {
      "span": 19
    }
  }, _vm._l((_vm.detailData.effect_sub_merchant), function(shop, index) {
    return _c('span', [_vm._v(_vm._s(shop.shopname) + _vm._s(index < _vm.detailData.effect_sub_merchant.length - 1 ? "、" : ""))])
  }))], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "title",
    attrs: {
      "span": 5
    }
  }, [_vm._v("活动开始时间")]), _vm._v(" "), _c('el-col', {
    staticClass: "desc",
    attrs: {
      "span": 19
    }
  }, [_vm._v(_vm._s(_vm.detailData.start_time))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "title",
    attrs: {
      "span": 5
    }
  }, [_vm._v("活动结束时间")]), _vm._v(" "), _c('el-col', {
    staticClass: "desc",
    attrs: {
      "span": 19
    }
  }, [_vm._v(_vm._s(_vm.detailData.expire_time))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "title",
    attrs: {
      "span": 5
    }
  }, [_vm._v("总预算")]), _vm._v(" "), _c('el-col', {
    staticClass: "desc",
    attrs: {
      "span": 19
    }
  }, [_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.detailData.total_amt)) + "元")])], 1), _vm._v(" "), _c('el-row', [(_vm.packetType === 0) ? [_c('el-col', {
    staticClass: "title",
    attrs: {
      "span": 5
    }
  }, [_vm._v("单个红包金额")]), _vm._v(" "), _c('el-col', {
    staticClass: "desc",
    attrs: {
      "span": 19
    }
  }, [_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.detailData.obtain_info.amt_max)) + "元")])] : _vm._e(), _vm._v(" "), (_vm.packetType === 1) ? [_c('el-col', {
    staticClass: "title",
    attrs: {
      "span": 5
    }
  }, [_vm._v("单个红包金额")]), _vm._v(" "), _c('el-col', {
    staticClass: "desc",
    attrs: {
      "span": 19
    }
  }, [_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.detailData.obtain_info.amt_min)) + " - " + _vm._s(_vm._f("formatCurrency")(_vm.detailData.obtain_info.amt_max)) + "元")])] : _vm._e()], 2), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "title",
    attrs: {
      "span": 5
    }
  }, [_vm._v("红包规则")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "desc"
  }, [_c('div', {
    staticClass: "desc-item"
  }, [_vm._v("会员微信扫描收款二维码"), _c('span', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.detailData.obtain_info.rule.amt)))]), _vm._v("元可返红包；")]), _vm._v(" "), _c('div', {
    staticClass: "desc-item"
  }, [_vm._v("红包领取后"), _c('span', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm.effectList[_vm.detailData.obtain_info.coupon_rule.effect_offset]) + ",")]), _c('span', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm.detailData.obtain_info.coupon_rule.effect_len))]), _vm._v("日内有效；")]), _vm._v(" "), _c('div', {
    staticClass: "desc-item"
  }, [_vm._v("会员有效期内微信扫描收款码"), _c('span', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.detailData.obtain_info.coupon_rule.use_rule.amt)))]), _vm._v("元以上可用；")])]), _vm._v(" "), _c('div', {
    staticClass: "remark"
  }, [_vm._v("备注：会员红包费用由商户承担")])])], 1)] : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f6a4eab"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/memberredpacket/memberredpacket.vue
// module id = 824
// module chunks = 1